module.exports = {
  baseUrl: 'https://travel.tgxwlkj.com/api/integration',
  title: '巩留县智慧旅游平台',
  storage: 'localStorage',
  tokenTableName: 'bscreen-Token',
  // 最长请求时间
  requestTimeout: 10000,
}
